




 const APIEndPoint = "https://inventoryapi.sysfore.com/api/";
//const APIEndPoint = "https://sysforeinventory-api.azurewebsites.net/api/";


//const APIEndPoint = "http://localhost:44324/api/";

export const isADLogin = true

export const AppSettings = {
  URLs: {
    getAllUsers: APIEndPoint + "UserData/GetAllUsersAsync",
    getUnassignUsers: APIEndPoint + "/AssetAllocate/GetAllUnAssignedUsersAsync",
    getUserById: APIEndPoint + "UserData/GetUserByIdAsync?id=",
    addUser: APIEndPoint + "UserData/AddUserDataAsync",
    updateUser: APIEndPoint + "UserData/UpdateUserDetailAsync",
    deleteUser: APIEndPoint + "UserData/DeleteUserDataAsync",
    asset: APIEndPoint + "",
    assetAllocate: APIEndPoint + "AssetAllocate/AssetAllocateAsync",
    updateAssetAllocate:
      APIEndPoint + "AssetAllocate/UpdateAssetAllocatedAsync",
    getAssetHistoryById: APIEndPoint + "AssetAllocate/GetAssetHistoryIdAsync",
    login: APIEndPoint + "Auth/VerifyUserLogin",
    adLogin: APIEndPoint + "Auth/AdLogin",
    getValueForProcessor: APIEndPoint + "Master/GetValueForProcessor?processorType=",

  },

  MasterData: {
    addDepartment: APIEndPoint + "Master/AddDepartment",
    updateDepartment: APIEndPoint + "Master/UpdateDepartment",
    getAllDepartment: APIEndPoint + "Master/GetAllDepartments",
    getDepartmentById: APIEndPoint + "Master/GetDepartmentById?id=",

    addDesignation: APIEndPoint + "Master/AddDesignation",
    updateDesignation: APIEndPoint + "Master/UpdateDesignation",
    getAllDesignation: APIEndPoint + "Master/GetAllDesignations",
    getDesignationById: APIEndPoint + "Master/GetDesignationById?id=",

    addProcessor: APIEndPoint + "Master/AddProcessor",
    updateProcessor: APIEndPoint + "Master/UpdateProcessor",
    getPrcessorType: APIEndPoint + "Master/GetProcessorType",

    addGenerations: APIEndPoint + "Master/AddGenerations",
    updateGenerations: APIEndPoint + "Master/UpdateGeneration",
    getAllGenerations: APIEndPoint + "Master/GetAllGenerations",

    addBrandType: APIEndPoint + "Master/AddBrandType",
    updateBrandType: APIEndPoint + "Master/UpdateBrandType",
    getAllBrandTypes: APIEndPoint + "Master/GetAllBrandTypes",

  },

  LoginUser: {
    addUser: APIEndPoint + "LoginUser/AddLoginUser",
    updateUser: APIEndPoint + "LoginUser/UpdateLoginUser",
    getAllLoginUsers: APIEndPoint + "LoginUser/GetAllLoginUsers",
    getLoginUserById: APIEndPoint + "LoginUser/GetLoginUserById?id=",
    getRoles: APIEndPoint + "LoginUser/GetRolesAsync"

  },

  Ewaste: {
    getEwasteAssetList: APIEndPoint + "EWaste/GetEWasteAssetListAsync",
    updateEwasteStatus: APIEndPoint + "EWaste/UpdateEWasteStatusAsync",
    createEwasteRequest: APIEndPoint + "EWaste/CreateEWasteRequestAsync",
    moveToEwaste: APIEndPoint + "EWaste/MoveToEWasteAsync",
    eWasteStatus: APIEndPoint + "EWaste/GetAllEWasteStatusAsync",
    getNotifications: APIEndPoint + "EWaste/GetNotificationsAsync",
    markNotificationRead: APIEndPoint + "EWaste/MarkNotificationReadAsync",
    getNotificationCount: APIEndPoint + "EWaste/GetNotificationCountAsync",
    reviewEwasteRequest: APIEndPoint + "EWaste/ReviewEWasteRequestAsync",

  }

};

